export const CREATE_INITIATIVES_REQUEST = 'CREATE_INITIATIVES_REQUEST';
export const CREATE_INITIATIVES_SUCCESS = 'CREATE_INITIATIVES_SUCCESS';
export const CREATE_INITIATIVES_FAILED = 'CREATE_INITIATIVES_FAILED';

export const GET_FORM_OPTIONS_REQUEST = 'GET_FORM_OPTIONS_REQUEST';
export const GET_FORM_OPTIONS_SUCCESS = 'GET_FORM_OPTIONS_SUCCESS';
export const GET_FORM_OPTIONS_FAILED = 'GET_FORM_OPTIONS_FAILED';
